import ajaxRequest from "../../utils/ajaxRequest";
import { API_PARAM } from "./apiParam";
import { API_QUERY } from "./apiQuery";

export default async function GetCBSAData(zipCode) {
    const promiseObj = new Promise(resolve => {
        ajaxRequest({
            url: API_QUERY.formulary.geographic.cbsas + zipCode,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${API_PARAM.token}`
            }
        })
            .then(res => {
                if (!res) {
                    resolve(false);
                    return;
                }
                const data = JSON.parse(res);
                resolve(data);
            })
            .catch(() => {
                resolve(false);
            });
    });
    return promiseObj;
}
